import axios from 'axios';

export default {
  namespaced: true,
  state: {
    loginData: {},
  },
  mutations: {
    login(state, {data}) {
      state.loginData = data;
    }
  },
  actions: {
    login({commit}, params = {}) {
      return axios.post('/account/ajax/login', {params: params}, {global: false}).then((data) => {
        // commit({ type: 'login', data: data });
        localStorage.setItem('user', JSON.stringify(data.data));
        return data;
      });
    },
    login2({commit}, params = {}) {
     
      return axios.post('/account/ajax/login2', {params: params}, {global: false}).then((data) => {
        return data;
      })
    },
    getWhost({commit}, params = {}) {
      return axios.post('/account/ajax/whost', {global: false}).then((data) => {
        return data;
      });
    },
    getShost({commit}, params = {}) {
      return axios.post('/account/ajax/shost', {global: false}).then((data) => {
        return data;
      });
    },
    getPromotionImg({commit}, params = {}) {
      return axios.post('/account/ajax/getPromotionImg', params, {global: false}).then((data) => {
        return data;
      });
    },
    wxAccountList({commit}, params) {
      return axios.get('/wx/ajax/accounts', {
        params: {
          mchId: params.mchId,
        },
        cache: true,
      }).then((data) => {
        return data;
      });
    }

  },
};
